import { InjectionToken } from '@angular/core';
import { marker as _ } from '@jsverse/transloco-keys-manager/marker';

export const defaultErrors: Record<string, string> = {
  required: _('form.errors.required'),
  minlength: _('form.errors.minlength'),
  maxlength: _('form.errors.maxlength'),
  min: _('form.errors.min'),
  max: _('form.errors.max'),
  email: _('form.errors.email'),
  passwordsNotMatch: _('form.errors.passwordsNotMatch'),
  notGreater: _('form.errors.notGreater'),
  notGreaterOrEqual: _('form.errors.notGreaterOrEqual'),
  matStartDateInvalid: _('form.errors.matStartDateInvalid'),
  matEndDateInvalid: _('form.errors.matEndDateInvalid'),
  objectNotUnique: _('form.errors.objectNotUnique'),
  invalidOpeningHoursFormat: _('form.errors.invalidOpeningHoursFormat'),
  invalidUrl: _('form.errors.invalidUrl'),
  unknown: _('form.errors.unknown'),
};

export const fileErrors: Record<string, string> = {
  notFound: _('form.errors.fileNotFound'),
  notReadable: _('form.errors.fileNotReadable'),
  empty: _('form.errors.fileEmpty'),
  tooLarge: _('form.errors.fileTooLarge'),
  invalidMimeType: _('form.errors.fileInvalidMimeType'),
  invalidExtension: _('form.errors.fileInvalidExtension'),
  filenameTooLong: _('form.errors.fileFilenameTooLong'),
  filenameInvalidCharacters: _('form.errors.fileFilenameInvalidCharacters'),
  unknownError: _('form.errors.fileUnknownError'),
};

export const FORM_ERRORS = new InjectionToken('FORM_ERRORS', {
  providedIn: 'root',
  factory: () => defaultErrors,
});
